import { render, staticRenderFns } from "./HeaderWithTooltip.vue?vue&type=template&id=8874570a&scoped=true&"
import script from "./HeaderWithTooltip.vue?vue&type=script&lang=js&"
export * from "./HeaderWithTooltip.vue?vue&type=script&lang=js&"
import style0 from "./HeaderWithTooltip.vue?vue&type=style&index=0&id=8874570a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8874570a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
